import { formatDistanceToNow } from 'date-fns';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, Modal, ModalHandle, TasksStore, Tooltip } from 'Mri.Web.Common';
import * as React from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import { AccountsStore } from '../Accounts/AccountsStore';
import { InvitesStore } from './InvitesStore';
import { BsFillCursorFill } from '@react-icons/all-files/bs/BsFillCursorFill';
import { BsTrash } from '@react-icons/all-files/bs/BsTrash';

export interface IInviteRowProps {
    readonly invitation: Mri.Web.Portal.Controllers.Invites.Invitation;
}

@autoinject
@observer
export class InviteRow extends React.Component<IInviteRowProps> {
    public render() {
        return (
            <tr>
                <td className="px-2">{this.props.invitation.email}</td>

                <td className={this.props.invitation.expired ? 'text-danger pe-2' : 'pe-2'}>
                    {this.props.invitation.expired
                        ? 'Expired'
                        : formatDistanceToNow(this.props.invitation.expiresAt, { addSuffix: true })}
                </td>

                <td className="pe-2">{this.props.invitation.roles}</td>

                <td className="pe-2">{this.accountNames.join(', ')}</td>

                <td className="pe-2">
                    <ButtonGroup className="py-1">
                        <Tooltip message="Delete" delay={0}>
                            <Button className="dt-border" color="danger" onClick={this.delete}>
                                <BsTrash className="" />
                            </Button>
                        </Tooltip>

                        <Tooltip message="Resend Invite" delay={0}>
                            <Button
                                id={'user-unlock-' + this.props.invitation.invitationId}
                                color="primary"
                                onClick={this.resend}
                            >
                                <BsFillCursorFill />
                            </Button>
                        </Tooltip>
                    </ButtonGroup>
                </td>
                <Modal
                    className="modal-sm"
                    title="Confirm Deletion"
                    modalHandle={this.deleteModalHandle}
                    btnClass="w-50"
                    footerClass="d-flex justify-content-center"
                >
                    <div className="text-center">Delete Invitation for {this.props.invitation.email}?</div>
                </Modal>
            </tr>
        );
    }

    @bind
    private async delete(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        if (await this.deleteModalHandle.confirm()) {
            const task = this.tasksStore.startSessionTask('Delete Invitation');

            try {
                await this.invitesStore.deleteAsync(this.props.invitation.invitationId);
                task.complete();
            } catch (e: any) {
                task.error(e);
            }
        }
    }

    @bind
    private async resend(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();
        const task = this.tasksStore.startSessionTask('Resend Invitation');

        try {
            this.invitesStore.resendInvite(this.props.invitation.invitationId);
            task.complete();
        } catch (e: any) {
            console.error(e);
            task.error(e);
        }
    }

    @computed
    private get accountNames() {
        if (!this.props.invitation.accounts) return [];

        return this.props.invitation.accounts.split(',').map(a => {
            const account = this.accountsStore.accounts.get(a);
            return account ? account.accountName : a;
        });
    }

    @observable
    private deleteModalHandle = new ModalHandle();
    @inject
    private invitesStore!: InvitesStore;
    @inject
    private tasksStore!: TasksStore;
    @inject
    private accountsStore!: AccountsStore;
}
